/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: flex;
  flex-direction: column;
}

:host > .item-wrapper {
  display: flex;
  max-inline-size: 100vw;
}

:host([layout=horizontal]) > .item-wrapper {
  flex-direction: row;
  flex-wrap: wrap;
}

:host([layout=horizontal][scale=s]) > .item-wrapper {
  column-gap: 1rem;
}

:host([layout=horizontal][scale=m]) > .item-wrapper {
  column-gap: 1.25rem;
}

:host([layout=horizontal][scale=l]) > .item-wrapper {
  column-gap: 1.5rem;
}

:host([layout=vertical]) > .item-wrapper {
  flex-direction: column;
  inline-size: -moz-fit-content;
  inline-size: fit-content;
}

:host([scale=s]) calcite-input-message {
  --calcite-input-message-spacing-value: calc(var(--calcite-spacing-xxs) * -1);
}

:host([scale=m]) calcite-input-message {
  --calcite-input-message-spacing-value: calc(var(--calcite-spacing-sm) * -1);
}

:host([scale=l]) calcite-input-message {
  --calcite-input-message-spacing-value: calc(var(--calcite-spacing-md) * -1);
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}